module.exports = __webpack_public_path__ + "img/product_report.d5f8ffa8.png";